<template>
  <!-- 商品详情页 -->
  <div class="group-detail" v-if="newDate">
    <!-- 引入公共头部 -->
    <dg-header :showBack="true" title="参团详情"></dg-header>
    <!-- banner轮播部分 -->
    <detail-banner :detailList="detailList"></detail-banner>
    <div class="section">
      <!-- banner 下商品信息 -->
      <goods-info :detailList="detailList" :price="price"></goods-info>
      <!-- 我要参团 -->
      <div class="tuxedo-wrap" v-if="newDate.groupBuy && newDate.groupOrder_doc && newDate.groupBuy.groupBuyPeople - newDate.groupOrder_doc.participateNum !== 0">
        <div class="tuxedo-countdown">
          还差
          <span
            class="specialColor"
          >{{newDate.groupBuy && newDate.groupBuy.groupBuyPeople - newDate.groupOrder_doc.participateNum}}</span>人拼团成功，
          <span v-if="newDate.groupOrder_doc ">{{times(this.newDate.groupOrder_doc.groupBuyEndTime)}}</span>

        </div>
        <ul class="tuxedo-group-member" v-if="newDate.groupOrder_doc && newDate.groupOrder_doc.userInfo">
          <li class="tuxedo-group-li "  v-for="(item, index) in newDate.groupOrder_doc.userInfo" :key="index">
            <span class="tuxedo-group-span" :class="userName === item.nickName ? 'self-br' : ''">
              <img :src="item.portrait" alt>
            </span>
            <p class="tuxedo-group-p" >{{index === 0 ? item.nickName+'(团长)' : item.nickName || '未知'}}</p>
          </li>
        </ul>
        <button class="tuxedo-group-btn" @click="showProup()" >我要参团</button>
      </div>
      <!-- 更多拼团火热进行中 -->
      <!-- <div class="more-group">
        <p class="more-group-title">更多火热拼团进行中</p>
        <ul class="more-group-con">
          <li class="more-group-li">
            <span class="more-group-span dg-small-no-photo">
              <img src="" alt="">
            </span>
            <p class="more-group-name">洗面奶，美白效果</p>
            <p class="more-group-price">2人拼，JPY 80.00</p>
          </li>
          <li class="more-group-li">
            <span class="more-group-span dg-small-no-photo">
              <img src="" alt="">
            </span>
            <p class="more-group-name">洗面奶，美白效果</p>
            <p class="more-group-price">2人拼，JPY 80.00</p>
          </li>
        </ul>
      </div>-->
    </div>
    <!-- 点击我要参团出现弹框 :type="type"-->
    <car-popup :detailList="detailList" :price="price" ref="showPopup" :type="type"></car-popup>
  </div>
</template>
<script>
import DgHeader from "@/components/header";
import DetailBanner from "../../product/product-detail/components/banner";
import GoodsInfo from "../../product/product-detail/components//goods-info";
import CarPopup from "../../../components/cart-popup";
import api from "@/server";
export default {
  data() {
    return {
      // 向子组件传参
      detailList: [],
      // 由于定时器影响数量步进器，重新赋值
      newDate: [],
      exchange: {},
      // 根据团单编号请求团单详情数据
      params: {
        groupOrderNumber: this.$route.query.groupOrderNumber
      },
      // 点击我要参团传类型，是拼团商品
      type: '',
      // 倒计时状态
      ticker: null,
      // 参考价格 usd美元 rmb人民币
      price: {
        usd: "",
        rmb: "",
        gbp: ""
      },
      userName: ''
    };
  },
  components: {
    DgHeader,
    DetailBanner,
    GoodsInfo,
    CarPopup
  },
  created() {
    this.userName = JSON.parse(localStorage.getItem('userInfo')).nickName;
    api
      .getSpellGroupDetail(this.params)
      .then(res => {
        // 防止进入页面出去后再进来计时器重复启动
        if (this.ticker) {
          clearInterval(this.ticker);
        }
        if (res.code === 200 && res.data.result) {
          this.detailList = res.data.result[0];
          this.exchange = res.data.exchRateList[0];
          this.price.rmb = Math.ceil(this.detailList.groupBuy.groupBuyPrice / this.exchange.rmb);
          this.price.usd = Math.ceil(this.detailList.groupBuy.groupBuyPrice / this.exchange.usd);
          this.price.gbp = Math.ceil(this.detailList.groupBuy.groupBuyPrice / this.exchange.gbp);
          // console.log(this.detailList)
        }
      })
      .catch(() => {});

  },
  methods: {
    // 点击我要参团弹出弹出层
    showProup(type) {
      this.type = 'join';
      this.$refs.showPopup.open();
    },
    // 计算时间戳
    times(time) {
      if (time >= 0) {
        let str = "";
        let h = Math.floor(time / 1000 / 60 / 60);
        let m = Math.floor((time / 1000 / 60) % 60);
        let s = Math.floor((time / 1000) % 60);
        h = h < 10 ? "0" + h : h;
        m = m < 10 ? "0" + m : m;
        s = s < 10 ? "0" + s : s;
        str = "还剩 " + h + ":" + m + ":" + s;
        return str;
      } else {
        return "活动已结束";
      }
    },
    // 计算倒计时的时间戳
    beginTimer() {
      this.ticker = setInterval(() => {
        // for (let i = 0, len = this.newDate.groupOrder_doc.length; i < len; i++) {
        //   const item = this.newDate.groupOrder_doc[i];
        //   if (item.groupBuyEndTime > 0) {
        this.newDate.groupOrder_doc.groupBuyEndTime = this.newDate.groupOrder_doc.groupBuyEndTime - 1000;
        //   }
        // }
      }, 1000);
    }
  },
  destroyed() {
    window.clearInterval(this.ticker);
    this.ticker = null;
  },
  watch: {
    detailList: {
      handler(val) {
        this.newDate = JSON.parse(JSON.stringify(val))
        if(val) {
          this.beginTimer();
        }
      }
    }

  },
};
</script>
<style lang="scss" scoped>
.group-detail {
  padding: 88px 0 100px;
  .header-wrap {
    position: fixed;
    top: 0;
    z-index: 9;
  }
  .specialColor {
    color: $fc04;
  }
  .section {
    padding: 30px;
  }
  .more-group,
  .tuxedo-wrap {
    width: 100%;
    height: auto;
    background: $fc02;
    padding: 30px;
    box-sizing: border-box;
    border-radius: $br20;
    margin-bottom: 8px;
    box-shadow: $box-shadow3;
    text-align: center;
  }
  /*我要参团*/
  .tuxedo-wrap {
    .tuxedo-countdown {
      text-align: center;
      font-size: 28px;
      color: $fc03;
    }
    .tuxedo-group-member {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      margin: 24px 0 20px;

      .tuxedo-group-li {
        margin: 0 20px;
        .self-br{
          border: 2px solid $fc04;
        }
        .tuxedo-group-span {
          width: 100px;
          height: 100px;
          background: url("../../../assets/images/no-login.png") no-repeat 0 0px/100%;
          border-radius: 50%;
          display: inline-block;
          overflow: hidden;
          text-align: center;
          > img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .tuxedo-group-p {
          text-align: center;
          margin-top: 8px;
          font-size: 22px;
          @include ellipsis();
        }
      }
    }
    .tuxedo-group-btn {
      width: calc(100% - 100px);
      height: 75px;
      display: inline-block;
      background: $btn02;
      margin: 0 auto;
      @include resetButton();
      border-radius: $br40;
      color: $fc02;
      font-size: 28px;
      &:active {
        background: $btnHover02;
      }
    }
  }
  /*更多拼团*/
  // .more-group{
  //   .more-group-title{
  //     font-size: 26px;
  //     color: $fc03;
  //   }
  //   .more-group-con{
  //     display: flex;
  //     justify-content:space-around;
  //     margin-top: 20px;
  //     .more-group-li{
  //       .more-group-span{
  //         width: 300px;
  //         height: 240px;
  //         display: inline-block;
  //         overflow: hidden;
  //         >img{
  //           width: 100%;
  //           height: 100%;
  //           object-fit: fill;
  //         }
  //       }
  //       .more-group-name{
  //         font-size: 24px;
  //       }
  //       .more-group-price{
  //         font-size: 22px;
  //         margin-top: 6px;
  //       }
  //     }
  //   }
  // }
}
</style>

